import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const line = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1, ease: EASE, delay: 0.08 * i } }),
};

export const MaskLines = ({ lines, as: Tag = "h2", className = "", onLoad = false, testId }) => {
  const trigger = onLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <motion.div {...trigger}>
      <Tag className={className} data-testid={testId}>
        {lines.map((l, i) => (
          <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
            <motion.span className="block" variants={line} custom={i + (onLoad ? 3 : 0)}>
              {l}
            </motion.span>
          </span>
        ))}
      </Tag>
    </motion.div>
  );
};

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono-k text-[11px] sm:text-xs uppercase tracking-[0.28em] text-[#E3C45A] flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-[#D4AF37]/70" />
    {children}
  </p>
);
